import {
  bajaUsuario, newUsuario, obtenerUsuarioByIdUsuario, obtenerUsuarioProfile, obtenerUsuariosTipoUsuario, updateUsuario,
  getAgentes, changePasswordByUser
} from "../services/serviceUsuarios";

const dataInicial = {
  agentes: [],
  array: [],
  exito: 0,
  profile: {},
  IdTipoUsuario: 0,
  usuario: {},
};

const GET_AGENTES = "GET_AGENTES";
const GET_USUARIOS_CLEAR_STATE = "GET_USUARIOS_CLEAR_STATE";
const GET_USUARIOS_PROFILE = "GET_USUARIOS_PROFILE";
const GET_USUARIOS_ALL = "GET_USUARIOS_ALL";
const GET_USUARIOS_BY_ID = "GET_USUARIOS_BY_ID";
const DELETE_USUARIOS_ESTATUS = "DELETE_USUARIOS_ESTATUS";
const POST_USUARIOS_NEW = "POST_USUARIOS_NEW";
const PUT_USUARIOS_USUARIO = "PUT_USUARIOS_USUARIO";
const PUT_USUARIOS_PASSWORD_CHANGE = "PUT_USUARIOS_PASSWORD_CHANGE"

export default function usuariosReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_AGENTES:
      return { ...state, agentes: action.payload.agentes }
    case GET_USUARIOS_BY_ID:
      return { ...state, usuario: action.payload.usuario }
    case PUT_USUARIOS_USUARIO:
      return { ...state, exito: action.payload.exito, array: action.payload.array }
    case PUT_USUARIOS_PASSWORD_CHANGE:
      return { ...state, exito: action.payload.exito, array: action.payload.array }
    case POST_USUARIOS_NEW:
      return { ...state, exito: action.payload.exito, array: action.payload.array }
    case GET_USUARIOS_ALL:
      return { ...state, array: action.payload.array, IdTipoUsuario: action.payload.IdTipoUsuario };
    case DELETE_USUARIOS_ESTATUS:
      return { ...state, exito: action.payload.exito };
    case GET_USUARIOS_PROFILE:
      return { ...state, profile: action.payload.profile };
    case GET_USUARIOS_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
        profile: action.payload.profile,
      };
    default:
      return state;
  }
}
export const obtenerAgentes = () => async (dispatch) => {
  const agentes = await getAgentes();
  dispatch({
    type: GET_AGENTES,
    payload: {
      agentes: agentes,
    },
  });
  return agentes;
}
export const bajaUsuariosAction = (idUsuario, estatus) => async (dispatch) => {
  const response = await bajaUsuario({ idUsuario, estatus });
  dispatch({
    type: DELETE_USUARIOS_ESTATUS,
    payload: {
      exito: response,
    },
  });
  return response;
}
export const obtenerProfileAction = () => async (dispatch) => {
  const usuarioProfile = await obtenerUsuarioProfile();
  dispatch({
    type: GET_USUARIOS_PROFILE,
    payload: {
      profile: usuarioProfile,
    },
  });
  return usuarioProfile;
};
export const obtenerUsuariosAction = (IdTipoUsuario) => async (dispatch) => {
  return await obtenerUsuariosTipoUsuario({ IdTipoUsuario }).then((Response) => {
    dispatch({
      type: GET_USUARIOS_ALL,
      payload: {
        array: Response,
        IdTipoUsuario: IdTipoUsuario,
      },
    });
  }).catch((Error) => {
    return [];
  })
}
export const changePasswordAction = ({ IdUser, PasswordHash }) => async (dispatch, getState) => {
  const IdTipoUsuario = getState().usuarios.IdTipoUsuario;
  const newUser = await changePasswordByUser({ IdUser, password: PasswordHash });
  const newArray = await obtenerUsuariosTipoUsuario({ IdTipoUsuario });
  dispatch({
    type: PUT_USUARIOS_PASSWORD_CHANGE,
    payload: {
      exito: 1,
      array: newArray,
    },
  });
  return newUser;
}
export const newUsuariosAction = (payload) => async (dispatch, getState) => {
  try {
    const IdTipoUsuario = getState().usuarios.IdTipoUsuario;
    const newUser = await newUsuario({ payload });
    const newArray = await obtenerUsuariosTipoUsuario({ IdTipoUsuario });
    dispatch({
      type: POST_USUARIOS_NEW,
      payload: {
        exito: 1,
        array: newArray,
      },
    });
    return newUser;
  } catch (error) {
    return { status: 500 }
  }
}
export const updateUsuarioAction = (IdUsuario, payload) => async (dispatch, getState) => {
  try {
    const IdTipoUsuario = getState().usuarios.IdTipoUsuario;
    const updateUser = await updateUsuario({ IdUsuario, payload });
    const newArray = await obtenerUsuariosTipoUsuario({ IdTipoUsuario });
    dispatch({
      type: PUT_USUARIOS_USUARIO,
      payload: {
        exito: 1,
        array: newArray,
      },
    });
    return updateUser;
  } catch (error) {
    return { status: 500 }
  }
}
export const obtenerUsuariobyIdAction = (IdUsuario) => async (dispatch) => {
  return obtenerUsuarioByIdUsuario({ IdUsuario }).then((Response) => {
    dispatch({
      type: GET_USUARIOS_BY_ID,
      payload: {
        usuario: Response,
      },
    });
    return Response;
  }).catch((Error) => {
    return Error;
  })
}
export const clearUsuarioState = () => async (dispatch) => {
  dispatch({
    type: GET_USUARIOS_CLEAR_STATE,
    payload: dataInicial,
  });
};
